export default "__VITE_ASSET__BBOSgNnO__"